import { lazy } from "react";

const Ticket = lazy(() => import("../Component/Ticket/Ticket"));
const Chat = lazy(() => import("../Component/Ticket/Chat"));
const Addticket = lazy(() => import("../Component/Ticket/Addticket"));

const ticketRoutes = [
  { path: "/manage-ticket", element: <Ticket />, protected: true },
  { path: "/view-chat/:id", element: <Chat />, protected: true },
  { path: "/add-ticket", element: <Addticket />, protected: true },
];

export default ticketRoutes;
